import useApiQuery from 'shared/hooks/use-api-query';
import companiesKeys from '../util/companies-keys';
import {CompanyProps} from '../types';

const useCompanyDetails = (companyId?: string) => {
  return useApiQuery<CompanyProps>({
    url: `/companies/${companyId}`,
    queryKey: companiesKeys.details(companyId!),
    enabled: !!companyId,
  });
};

export default useCompanyDetails;
